import { Achievement } from '@/types';
import { SAMPLE_USER_IDS } from './users';

const now = new Date('2024-09-01T00:00:00.000Z');
const userId = SAMPLE_USER_IDS.student;

export const sampleAchievements: Achievement[] = [
  // ── Unlocked ──────────────────────────────────────────────────────────────
  {
    id: 'ach_first_path',
    _id: 'ach_first_path',
    userId,
    name: 'Pathfinder',
    title: 'Pathfinder',
    description: 'Added your first career path. The journey begins!',
    icon: 'MapPin',
    points: 50,
    xpReward: 50,
    unlocked: true,
    unlockedAt: now,
    category: 'career',
    progress: 100,
    rarity: 'common',
    requirements: { type: 'paths_added', threshold: 1, currentProgress: 1 },
    badgeColor: '#0ea5e9',
    createdAt: now,
  },
  {
    id: 'ach_assessment_done',
    _id: 'ach_assessment_done',
    userId,
    name: 'Self-Aware',
    title: 'Self-Aware',
    description: 'Completed the Psychometric Assessment and unlocked your full trait profile.',
    icon: 'Brain',
    points: 75,
    xpReward: 75,
    unlocked: true,
    unlockedAt: now,
    category: 'milestone',
    progress: 100,
    rarity: 'common',
    requirements: { type: 'assessment_completed', threshold: 1, currentProgress: 1 },
    badgeColor: '#6366f1',
    createdAt: now,
  },
  {
    id: 'ach_first_module',
    _id: 'ach_first_module',
    userId,
    name: 'First Step',
    title: 'First Step',
    description: 'Completed your first learning module. Keep the momentum going!',
    icon: 'BookOpen',
    points: 40,
    xpReward: 40,
    unlocked: true,
    unlockedAt: now,
    category: 'academic',
    progress: 100,
    rarity: 'common',
    requirements: { type: 'modules_completed', threshold: 1, currentProgress: 1 },
    badgeColor: '#10b981',
    createdAt: now,
  },

  // ── Locked — in progress ──────────────────────────────────────────────────
  {
    id: 'ach_five_games',
    _id: 'ach_five_games',
    userId,
    name: 'Game On',
    title: 'Game On',
    description: 'Play 5 subject games to earn trait points the fun way.',
    icon: 'Gamepad2',
    points: 60,
    xpReward: 60,
    unlocked: false,
    category: 'engagement',
    progress: 20,
    rarity: 'common',
    requirements: { type: 'games_played', threshold: 5, currentProgress: 1 },
    badgeColor: '#f59e0b',
    createdAt: now,
  },
  {
    id: 'ach_trait_70',
    _id: 'ach_trait_70',
    userId,
    name: 'Rising Talent',
    title: 'Rising Talent',
    description: 'Reach a score of 70 or higher in any trait.',
    icon: 'TrendingUp',
    points: 100,
    xpReward: 100,
    unlocked: false,
    category: 'milestone',
    progress: 77,
    rarity: 'rare',
    requirements: { type: 'trait_score', threshold: 70, currentProgress: 54 },
    badgeColor: '#8b5cf6',
    createdAt: now,
  },
  {
    id: 'ach_trait_80',
    _id: 'ach_trait_80',
    userId,
    name: 'Trait Master',
    title: 'Trait Master',
    description: 'Reach a score of 80 or higher in any trait. You\'re in the top tier!',
    icon: 'Star',
    points: 200,
    xpReward: 200,
    unlocked: false,
    category: 'milestone',
    progress: 68,
    rarity: 'epic',
    requirements: { type: 'trait_score', threshold: 80, currentProgress: 54 },
    badgeColor: '#ef4444',
    createdAt: now,
  },
  {
    id: 'ach_streak_7',
    _id: 'ach_streak_7',
    userId,
    name: 'On a Roll',
    title: 'On a Roll',
    description: 'Log in and engage for 7 days in a row. Consistency is your superpower.',
    icon: 'Flame',
    points: 80,
    xpReward: 80,
    unlocked: false,
    category: 'streak',
    progress: 43,
    rarity: 'rare',
    requirements: { type: 'login_streak', threshold: 7, currentProgress: 3 },
    badgeColor: '#f97316',
    createdAt: now,
  },
  {
    id: 'ach_three_activities',
    _id: 'ach_three_activities',
    userId,
    name: 'Go-Getter',
    title: 'Go-Getter',
    description: 'Log 3 real-world extracurricular activities in the Activity Log.',
    icon: 'ClipboardList',
    points: 50,
    xpReward: 50,
    unlocked: false,
    category: 'engagement',
    progress: 0,
    rarity: 'common',
    requirements: { type: 'activities_logged', threshold: 3, currentProgress: 0 },
    badgeColor: '#0ea5e9',
    createdAt: now,
  },
  {
    id: 'ach_ten_activities',
    _id: 'ach_ten_activities',
    userId,
    name: 'Overachiever',
    title: 'Overachiever',
    description: 'Log 10 real-world activities. You live and breathe growth!',
    icon: 'Trophy',
    points: 200,
    xpReward: 200,
    unlocked: false,
    category: 'engagement',
    progress: 0,
    rarity: 'epic',
    requirements: { type: 'activities_logged', threshold: 10, currentProgress: 0 },
    badgeColor: '#f59e0b',
    createdAt: now,
  },
  {
    id: 'ach_level_5',
    _id: 'ach_level_5',
    userId,
    name: 'Level Up',
    title: 'Level Up',
    description: 'Reach Level 5 on the platform. You\'re becoming a serious contender.',
    icon: 'Zap',
    points: 300,
    xpReward: 300,
    unlocked: false,
    category: 'milestone',
    progress: 20,
    rarity: 'epic',
    requirements: { type: 'user_level', threshold: 5, currentProgress: 1 },
    badgeColor: '#6366f1',
    createdAt: now,
  },
];
